// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M13 12H7V10H13V12Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M17 8H7V6H17V8Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M21 13H23V22H1V13H3V2H21V13ZM5 13H8.90137L9.09473 13.751C9.42791 15.045 10.6036 16 12 16C13.3964 16 14.5721 15.045 14.9053 13.751L15.0986 13H19V4H5V13Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-draft-filled')
export default class DraftFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'draft-filled',
    }
  }
}
